import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { ButtonFilled, Text, SvgIcon, Flex, Box } from '../../Base';

const DownloadableItemContainer = styled((props) => (
  <Flex justifyContent={'space-between'} alignItems={'center'} {...props} />
))`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.greyscale.grey5}`};
`;
class DownloadableItem extends Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    content: PropTypes.shape({
      data: PropTypes.object,
    }),
    alignItems: Flex.propTypes.alignItems,
    onDownloadClick: PropTypes.func,
  };

  static defaultProps = {
    alignItems: 'center',
    onDownloadClick: () => {},
  };

  componentDidCatch(error, info) {
    console.error(error, info);
    return null;
  }

  render() {
    const { title, referId, description, content, onDownloadClick, t, ...restProps } = this.props;
    if (content && content.data) {
      const { key } = content.data;
      return (
        <DownloadableItemContainer py={5} px={6} {...restProps}>
          <Box>
            <SvgIcon
              icon={SvgIcon.ICON_LIST.ATTACHMENT}
              size={24}
              style={{ transform: 'rotate(-45deg)' }}
            />
          </Box>
          <Text style={{ flexGrow: 1 }} px={2}>
            {title}
          </Text>
          <ButtonFilled
            color={'coolGrey.grey3'}
            textColor={'text'}
            py={1}
            px={1}
            onClick={() => {
              onDownloadClick(key, referId);
            }}
          >
            <Flex justifyContent={'center'} alignItems={'center'}>
              <SvgIcon icon={SvgIcon.ICON_LIST.DOWNLOAD} size={12} mr={1} color={'text'} />
              <Text textStyle={'caption'}>{t('BUTTON.DOWNLOAD')}</Text>
            </Flex>
          </ButtonFilled>
        </DownloadableItemContainer>
      );
    }
    return null;
  }
}

export default withTranslation('classroom')(DownloadableItem);
